import { SubscriptionHistoryType } from "../../../common/types/subscription.types";
import { HistoryEvent } from "../../../common/types/subscription.types";

export const historyEvents: HistoryEvent[] = [
  {
    id: "account-created",
    type: SubscriptionHistoryType.AccountCreated,
    icon: "user",
    details: {
      name: "Mark Lamb",
      date: "01/11/2025",
    },
  },
  {
    id: "trial-started",
    type: SubscriptionHistoryType.TrialStarted,
    icon: "check",
    details: {
      days: "15 Days",
      expiringDate: "15/11/2025",
    },
  },
  {
    id: "trial-extended",
    type: SubscriptionHistoryType.TrialExtended,
    icon: "check",
    details: {
      days: "+ 7 Days",
      expiringDate: "22/11/2025",
    },
  },
  {
    id: "extend-time-request",
    type: SubscriptionHistoryType.ExtendTimeRequest,
    icon: "user",
    details: {
      days: "+ 7 Days",
      byUser: "Sarah Johnson",
      reason: "Extend time request",
    },
  },
  {
    id: "time-approved",
    type: SubscriptionHistoryType.TimeApproved,
    icon: "check",
    details: {
      days: "+ 30 Days",
      byUser: "Admin",
      date: "30/11/2025",
    },
  },
  {
    id: "account-suspended",
    type: SubscriptionHistoryType.AccountSuspended,
    icon: "user",
    details: {
      text: "Suspended due to payment issue",
    },
  },
  {
    id: "converted-subscription",
    type: SubscriptionHistoryType.ConvertedSubscription,
    icon: "check",
    details: {
      subscriptionName: "Premium Plan",
      date: "01/11/2025",
      variant: "converted",
    },
  },
  {
    id: "subscription-changed",
    type: SubscriptionHistoryType.SubscriptionChanged,
    icon: "check",
    details: {
      subscriptionName: "Enterprise Plan",
      date: "01/11/2025",
      variant: "changed",
    },
  },
];

